import { ChatBotSettingsFormValues } from "@jugl-web/domain-resources/chat-bot";
import { Switch } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import React from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { InfoIndicator } from "../../../../components/InfoIndicator";
import { Separator } from "../../../../components/Separator";
import { TabHeader } from "../../../../components/TabHeader";
import {
  useVoiceFilters,
  VoiceAgentVoiceFilters,
  VoiceAgentVoicePicker,
} from "../../../../components/VoiceAgentVoicePicker";
import { AppearanceSettingsTabShell } from "../AppearanceSettingsTabShell";

export const VoiceChatTabContent: React.FC = () => {
  return (
    <AppearanceSettingsTabShell tabId="voiceMode" previewMode="default">
      <VoiceChatTabContentInner />
    </AppearanceSettingsTabShell>
  );
};

const VoiceChatTabContentInner: React.FC = () => {
  const { t } = useTranslations();
  const { control } = useFormContext<ChatBotSettingsFormValues>();
  const { filtersProps, pickerProps } = useVoiceFilters();

  const isVoiceModeEnabled = useWatch({
    control,
    name: "voice_config.enabled",
  });

  return (
    <>
      <TabHeader
        title={
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-2.5">
              <Controller
                control={control}
                name="voice_config.enabled"
                render={({ field: { value, onChange } }) => (
                  <Switch
                    isChecked={value}
                    onChange={(checked) => onChange(checked)}
                  />
                )}
              />
              <span>
                {t({
                  id: "client-support-page.voice-mode",
                  defaultMessage: "Voice mode",
                })}
              </span>
            </div>
            <InfoIndicator
              message={t({
                id: "client-support-page.voice-mode-tooltip",
                defaultMessage:
                  "AI Agent will use default Instructions to answer your Customers in Voice mode ℹ️",
              })}
            />
          </div>
        }
        subtitle={t(
          {
            id: "client-support-page.voice-chat-tab-subtitle",
            defaultMessage:
              "Talk to AI Agent in live.{br}See conversation transcript in Inbox",
          },
          { br: <br /> }
        )}
      />
      <Separator className="my-8" />
      <div className="flex flex-col gap-6">
        <VoiceAgentVoiceFilters
          {...filtersProps}
          isDisabled={!isVoiceModeEnabled}
        />
        <VoiceAgentVoicePicker
          name="voice_config.voice"
          {...pickerProps}
          isDisabled={!isVoiceModeEnabled}
        />
      </div>
    </>
  );
};
